/** Recette Change Management (25.10.2026) : « 02 Cadrage & trajectoire CAP » (capture) = « Cadrage & trajectoire CAP » (page) ;
 * la numérotation de tête, la casse, les apostrophes et les espaces ne comptent pas. Un autre libellé demande un choix au Maker. */
export const samePageLabel=(page:string|undefined,capture:string|undefined):boolean=>{
 const norm=(value:string)=>value.normalize('NFC').replace(/[‘’ʼ]/g,"'").replace(/^\s*(?:[A-Za-z]{0,2}\d{1,3})\s*[·.)\-–—:]?\s+/,'').replace(/\s+/g,' ').trim().toLocaleLowerCase('fr');
 return !!page&&!!capture&&norm(page)!==''&&norm(page)===norm(capture);
};
/** Clé d'une nouvelle page : préfixe du module + libellé en minuscules sans accents (motif des clés de page), unique. */
export function newPageKey(code:string,label:string,taken:string[]):string{
 const slug=label.normalize('NFD').replace(/\p{M}/gu,'').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'').slice(0,30)||'page';
 const base=`${code.toLowerCase().replace(/[^a-z0-9]+/g,'-').slice(0,10)}-${slug}`.replace(/^[^a-z]+/,'');let key=base;let n=2;
 while(taken.includes(key))key=`${base}-${n++}`;
 return key;
}
